import { render, staticRenderFns } from "./GameEnd.vue?vue&type=template&id=68e032df&scoped=true&"
import script from "./GameEnd.vue?vue&type=script&lang=js&"
export * from "./GameEnd.vue?vue&type=script&lang=js&"
import style0 from "./GameEnd.vue?vue&type=style&index=0&id=68e032df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e032df",
  null
  
)

export default component.exports